import { create } from 'zustand';

type SelectedVoorschrift = {
  id: string;
  type: 'voorschrift';
};

type SelectedSubparagraaf = {
  id: string;
  type: 'subparagraaf';
};

type SelectedParagraaf = {
  id: string;
  type: 'paragraaf';
};

type SelectedHoofdstuk = {
  id: string;
  type: 'hoofdstuk';
};

type SelectedObject =
  | SelectedVoorschrift
  | SelectedSubparagraaf
  | SelectedParagraaf
  | SelectedHoofdstuk;

export type EditorView = 'default' | 'add' | 'dragndrop' | 'recover';

interface EditorStoreState {
  view: EditorView;
  isSidebarLeftOpen: boolean;
  selectedObject?: SelectedObject;
  includeCheckedComments: boolean;
}

interface EditorStoreActions {
  setView: (view: EditorStoreState['view']) => void;
  setSidebarLeftOpen: (isOpen: boolean) => void;
  reset: () => void;
  selectObject: (selectedObject: SelectedObject) => void;
  clearSelectedObject: () => void;
  setIncludeCheckedComments: (includeCheckedComments: boolean) => void;
}

export const EDITOR_STORE_INITIAL_STATE: EditorStoreState = {
  view: 'default',
  isSidebarLeftOpen: false,
  selectedObject: undefined,
  includeCheckedComments: false,
};

export const useEditorStore = create<EditorStoreState & EditorStoreActions>(
  (set) => ({
    ...EDITOR_STORE_INITIAL_STATE,
    setView: (view) => set({ view }),
    setSidebarLeftOpen: (isSidebarLeftOpen) => set({ isSidebarLeftOpen }),
    reset: () => set({ ...EDITOR_STORE_INITIAL_STATE }),
    selectObject: (selectedObject) => set({ selectedObject }),
    clearSelectedObject: () => set({ selectedObject: undefined }),
    setIncludeCheckedComments: (includeCheckedComments) =>
      set({ includeCheckedComments }),
  })
);
